define([
	"dojo/_base/declare",
	"csi/action",
	"csi/breadcrumb/StateActionController",
	"csi/widget/MessageDialog",
	"csi/xml"
], function(declare,csiAction,StateActionController,MessageDialog,xml) {

	return declare(StateActionController, {
		preProcess: function() {
			var nodeRevision = this.getNode();

			if (xml.isValidURL(nodeRevision.Phase)) {
				this.confirmAction();
			} else {
				this.confirmAction({message: this.getString(csiAction.SUFFIX_CONFIRM + "_NoPhases")});
			}
		},

		onConfirm: function(/*String*/key) {
			if ((key == MessageDialog.BUTTON_PURGE) || (key == MessageDialog.BUTTON_PURGE_RESET)) {
				// because action can cause many changes, we will query for the modified nodes explicitly as needed;
				// purge action does not generate any new nodes, so default parameters will suffice
				this.m_action.setReturnParameters();
				StateActionController.prototype.preProcess.call(this);
			} else {
				this.postProcess();
			}
		}
	});
});